<div class="dialog-content-wrapper">
  <form [formGroup]="editForm" class="k-form-inline">

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="organisation_name">Organisation Name</label>
      <div class="col-8">
        <input type="text" id="organisation_name" formControlName="organisation_name" class="form-control" appAutoFocus>
        <div *ngIf="organisation_name?.invalid" class="alert alert-danger">
          <div *ngIf="organisation_name?.errors?.['required']">Organisation Name is required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="business_owner_name">Business Owner</label>
      <div class="col-8">
        <input type="text" id="business_owner_name" formControlName="business_owner_name" class="form-control"
          appAutoFocus>
        <div *ngIf="business_owner_name?.invalid" class="alert alert-danger">
          <div *ngIf="business_owner_name?.errors?.['required']">Business Owner is required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="contact_email">Contact Email</label>
      <div class="col-8">
        <input type="text" id="contact_email" formControlName="contact_email" class="form-control" appAutoFocus
          style="text-transform: lowercase;">
        <div *ngIf="contact_email?.invalid" class="alert alert-danger">
          <div *ngIf="contact_email?.errors?.['required']">Contact Email is required.</div>
          <div *ngIf="contact_email?.errors?.['email']">Please enter a valid email address.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="contact_telephone">Contact Telephone Number</label>
      <div class="col-8">
        <input type="text" id="contact_telephone" formControlName="contact_telephone" class="form-control" appAutoFocus>
        <div *ngIf="contact_telephone?.invalid" class="alert alert-danger">
          <div *ngIf="contact_telephone?.errors?.['required']">Contact Telephone Number is required.</div>
          <div *ngIf="contact_telephone?.errors?.['pattern']">Please enter a valid telephone number.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="address">Address</label>
      <div class="col-8">
        <textarea class="form-control" id="address" formControlName="address" rows="4" style="width:100%;"
          appAutoFocus></textarea>
      </div>
    </div>


    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="student_email_template">Student Email Template</label>
      <div class="col-8">
        <casi-kendo-editor [value]="studentEmailTemplate"
          (onValueChange)="studentEmailTemplateChange($event)"></casi-kendo-editor>
        <input hidden type="text" class="form-control" formControlName="student_email_template"
          id="student_email_template">
        <div *ngIf="student_email_template?.invalid" class="alert alert-danger">
          <div *ngIf="student_email_template?.errors?.['required']">Student Email Template is required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="supervisor_email_template">Supervisor Email Template</label>
      <div class="col-8">
        <casi-kendo-editor [value]="supervisorEmailTemplate"
          (onValueChange)="supervisorEmailTemplateChange($event)"></casi-kendo-editor>
        <input hidden type="text" class="form-control" formControlName="supervisor_email_template"
          id="supervisor_email_template">
        <div *ngIf="supervisor_email_template?.invalid" class="alert alert-danger">
          <div *ngIf="supervisor_email_template?.errors?.['required']">Supervisor Email Template is required.</div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="editForm.errors?.['duplicateOrganisation']">
      That organisation already exists.
    </div>

    <!--  <div class="k-form-field">-->
    <!--    <label for="logo" class="form-label col-3">Organisation Logo Image</label>-->
    <!--    <div class="col-4">-->
    <!--      <kendo-upload id="logo" name="logo" [autoUpload]="false"-->
    <!--                     [restrictions]="myRestrictions" [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl"-->
    <!--                    (cancel)="cancel($event)" (clear)="clear()" (complete)="complete()" (error)="error($event)"-->
    <!--                    (blur)="blur()" (focus)="focus()" (pause)="pause($event)" (remove)="remove($event)"-->
    <!--                    (resume)="resume($event)" (select)="select($event)" (success)="success($event)" (upload)="upload($event)"-->
    <!--                    (uploadProgress)="uploadProgress($event)" (valueChange)="valueChange($event)">-->
    <!--      </kendo-upload>-->
    <!--    </div>-->
    <!--    <div class="col-1">-->
    <!--      <div kendoTooltip style="text-align: center; padding-top: 10px;" *ngIf="hasLogo">-->
    <!--        <button kendoButton title="Clear Business Logo" class="btn btn-lg"-->
    <!--                (click)="clearLogo()"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'ban']"></fa-icon></button>-->

    <!--      </div>-->

    <!--    </div>-->
    <!--    <div class="col-3">-->
    <!--    <img id="logoImage" src="data:image/jpeg;base64,{{logo}}" style="max-width: 100%; max-height: 100px;" *ngIf="hasLogo" />-->

    <!--      <img id="logoImage2" style="max-width: 100%; max-height: 100px;" *ngIf="!hasLogo"/>-->

    <!--    </div>-->

    <!--    </div>-->

  </form>
</div>
<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
